import React, { useEffect, useState } from "react";
import ReactSelect, { components } from "react-select";
import { get } from "../Libraries/Ajax/HttpService";
import { useDistrict } from "../utils/DistrictContext";
import { useTheme } from "../context/ThemeContext";
// const customSelectStyles = {
//   control: (base, state) => ({
//     ...base,
//     backgroundColor: "#0a1628", // Matches your Tailwind bg
//     borderColor: state.isFocused ? "#00b8f1" : "#2a2520", // Matches border and focus blue
//     borderRadius: "0.5rem", // rounded-lg
//     padding: "2px 6px",
//     boxShadow: "none",
//     "&:hover": {
//       borderColor: "#00b8f1",
//     },
//   }),
//   menu: (base) => ({
//     ...base,
//     backgroundColor: "#0f1f30", // Slightly lighter navy for dropdown
//     border: "1px solid #2a2520",
//     zIndex: 9999,
//   }),
//   option: (base, state) => ({
//     ...base,
//     backgroundColor: state.isFocused ? "#00b8f120" : "transparent",
//     color: state.isSelected ? "#00b8f1" : "#fff",
//     "&:active": {
//       backgroundColor: "#00b8f140",
//     },
//   }),
//   multiValue: (base) => ({
//     ...base,
//     backgroundColor: "#00b8f120",
//     borderRadius: "4px",
//   }),
//   multiValueLabel: (base) => ({
//     ...base,
//     color: "#fff",
//   }),
//   multiValueRemove: (base) => ({
//     ...base,
//     color: "#00b8f1",
//     "&:hover": {
//       backgroundColor: "#00b8f140",
//       color: "#fff",
//     },
//   }),
//   input: (base) => ({
//     ...base,
//     color: "#fff",
//   }),
//   singleValue: (base) => ({
//     ...base,
//     color: "#fff",
//   }),
//   placeholder: (base) => ({
//     ...base,
//     color: "#BDB9B5",
//   }),
// };

const Option = (props) => (
  <components.Option {...props}>
    <label>{props.label}</label>
  </components.Option>
);

function ExamplesWithDistrict({ parentCallback }) {
  const districtContext = useDistrict();
  const { colors } = useTheme(); 
  const selectedDistrict =
    typeof districtContext === "string"
      ? districtContext
      : districtContext?.selectedDistrict || "";

  const [items, setItems] = useState([]);
  const [optionSelected, setOptionSelected] = useState([]);

  /** ---------------------------------------
   *  LOAD ACCOUNTS WHEN COMPONENT MOUNTS OR DISTRICT CHANGES
   *  --------------------------------------- */
  useEffect(() => {
    loadAccounts();
  }, [selectedDistrict]);

  /** ---------------------------------------
   *  API: Load Account List + Default Selection
   *  --------------------------------------- */
  const loadAccounts = async () => {
    try {
      const response = await get(
        `apis/account/overide_name/aggregate/select/list`,
      );

      const accountList = response?.data?.data?.account_override_list || [];
      const mappedItems = accountList.map(({ overided_name }) => ({
        label: overided_name,
        value: overided_name,
      }));

      const user = JSON.parse(localStorage.getItem("MCData"));

      let defaultSelection = [];

      // Apply your district logic
      if (selectedDistrict !== "FB151" && user?.userid) {
        defaultSelection = [
          { label: "PHMSCM Holdings", value: "PHMSCM Holdings" },
        ];
      } else {
        defaultSelection = mappedItems[0] ? [mappedItems[0]] : [];
      }

      setItems(mappedItems);
      setOptionSelected(defaultSelection);

      // Trigger category API if default exists
      if (defaultSelection.length > 0) {
        handleChange(defaultSelection);
      }
    } catch (error) {
      console.error("Failed to load accounts:", error);
    }
  };

  /** ---------------------------------------
   *  HANDLE CHANGE
   *  --------------------------------------- */
  const handleChange = async (selected) => {
    setOptionSelected(selected);

    const product = selected.map((item) => encodeURIComponent(item.value));

    try {
      const res = await get(
        `apis/category/account_override/select?selected=${JSON.stringify(
          product,
        )}`,
      );

      const selectedCategories =
        res?.data?.data?.categories?.selected_categories || [];

      if (typeof parentCallback === "function") {
        if (selectedCategories.length === 0) {
          parentCallback(res);
        } else {
          parentCallback(res, product);
        }
      }
    } catch (err) {
      console.error("API request failed:", err);
    }
  };

  /** ---------------------------------------
   *  RENDER
   *  --------------------------------------- */
  if (!items.length) return <div></div>;
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: colors.background, // Use dynamic background color from theme
      borderColor: state.isFocused ? colors.primary : colors.border, // Dynamic border color based on focus state
      borderRadius: "0.5rem", // Rounded corners
      padding: "2px 6px",
       maxHeight: "45px", // Set maximum height for the dropdown
    overflowY: "auto", // Enable vertical scrolling
      boxShadow: "none",
      "&:hover": {
        borderColor: colors.primary, // Hover border color
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: colors.background, // Menu background color
      border: `1px solid ${colors.border}`, // Menu border color
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? `${colors.primary}20` : "transparent", // Focused option background color
      color: state.isSelected ? colors.primary : colors.text, // Text color for selected option
      "&:active": {
        backgroundColor: `${colors.primary}40`, // Active option background
      },
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: `${colors.primary}20`, // Multi value background color
      borderRadius: "4px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: colors.text, // Multi value label color
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: colors.primary, // Remove button color
      "&:hover": {
        backgroundColor: `${colors.primary}40`, // Hover effect for remove button
        color: colors.text, // Hover text color
      },
    }),
    input: (base) => ({
      ...base,
      color: colors.text, // Input text color
    }),
    singleValue: (base) => ({
      ...base,
      color: colors.text, // Single value text color
    }),
    placeholder: (base) => ({
      ...base,
      color: colors.textSecondary, // Placeholder color
    }),
  };


  return (
    <span
      className="d-inline-block"
      data-toggle="popover"
      data-trigger="focus"
      data-content="Please select account(s)"
    >
      <ReactSelect
        // styles={{
        //   menuPortal: (base) => ({ ...base, zIndex: 99999 }),
        // }}
        styles={customSelectStyles}
        menuPortalTarget={document.body}
        options={items}
        isMulti
        value={optionSelected}
        onChange={handleChange}
        components={{ Option }}
      />
    </span>
  );
}

export default ExamplesWithDistrict;
